import React, { useMemo } from 'react';
import { AlertNotificationAndKey } from '@fullstory/client-api';
import { SegmentDetail } from '@fullstory/proto/fs/services/dx-objects';
import { Box, Flex, Typography } from '@fullstory/components';
import { notificationText } from '../../utils';
import css from './notificationAlertItem.module.scss';
import { getFormattedRelativeTime } from '@fullstory/util/date';

export const NotificationAlertItem: React.FC<{
  onClick?: () => void;
  newNotification?: boolean;
  notification: AlertNotificationAndKey;
  segment: SegmentDetail;
}> = ({ notification, newNotification, segment, onClick }) => {
  const createdDate = useMemo(
    () => getFormattedRelativeTime(new Date(notification?.Notification.CreatedAt)),
    [notification],
  );

  return (
    <Box
      data-component="NotificationAlertItem"
      padding={[16, 24, 0, 24]}
      onClick={onClick}
      className={css.container}
    >
      <Box paddingBottom={16}>
        <Flex justifyContent="space-between">
          <Typography variant="heading3" fontWeight={newNotification ? 'bold' : 'regular'}>
            {segment.segment?.segment?.name}
          </Typography>
          <Typography variant="body3" color={newNotification ? 'neutrals-n10' : 'neutrals-n7'}>
            {createdDate}
          </Typography>
        </Flex>
        <Flex justifyContent="flex-start">
          <Typography
            variant="body3"
            color={newNotification ? 'neutrals-n10' : 'neutrals-n7'}
            className="fs-block"
          >
            {notificationText(notification.Notification)}
          </Typography>
        </Flex>
      </Box>
    </Box>
  );
};
